<div class="container">
  <div class="row padding-row">
    <div class="col-md-1"><img src="assets/images/confetti-5-dots.svg" class="confetti-5-dots" /></div>
    <div class="col-md-2 padding-diamond">
      <div class="results-diamond" [ngClass]="{ locked: !isComplete || isShowingEmptyState() }">
        <div class="diamond-content">
          <img src="assets/images/lock.svg" *ngIf="!isComplete || isShowingEmptyState(); else teamTypeDiamond" />
          <ng-template #teamTypeDiamond>
            {{ mbtiType | lowercase }}
            <div class="initials d-none d-md-block" *ngIf="showIndividual" [ngStyle]="{ background: initialsColor, border: initialsBorder }">
              {{ initials }}
            </div>
          </ng-template>
        </div>
      </div>
      <div
        class="content mobile team"
        *ngIf="!isShowingEmptyState(); else lockedDownMobileView"
        [ngClass]="darkBackground ? 'dark-background' : 'light-background'"
      >
        <div class="name">{{ name }}</div>
        <div class="description">{{ description }}</div>
      </div>
    </div>
    <div class="col-md-8 col-sm-6 padding-copy" *ngIf="!isShowingEmptyState(); else lockedDownView">
      <div style="padding-left: 4.125rem">
        <div class="content desktop team" [ngClass]="darkBackground ? 'dark-background' : 'light-background'">
          <div class="name">{{ name }}</div>
          <div class="description">{{ description }}</div>
        </div>
        <div class="d-none d-md-block w-100">
          <div *ngIf="isTeamView; else individualViewDeskTop">
            <div class="padding-buttons" [ngClass]="{ complete: isComplete }" *ngIf="!isShowingEmptyState()">
              <div>
                <button
                  type="button"
                  class="d-flex justify-content-center align-items-center"
                  [ngClass]="!isComplete ? 'btn-gray' : 'btn-primary'"
                  [disabled]="!isComplete || !isTeamReportDownloadButtonActivated"
                  (click)="downloadTeamTypeReport()"
                >
                  <span *ngIf="!isTeamReportDownloadButtonActivated" class="d-flex justify-content-center align-items-center">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </span>
                  <span>Download Your Team Type Report</span>
                </button>
                <a
                  class="btn btn-white d-flex justify-content-center align-items-center"
                  href="https://e4hm6dz7g3.cpp.com/support/guides/Self-Directed-Teams-Facilitators-Guide-V2.pptx"
                  >Download Facilitator's Guide</a
                >
              </div>
              <div class="button-spacer"></div>
              <div *ngIf="router.url !== '/team/profile'">
                <button
                  type="button"
                  [ngClass]="!isComplete ? 'btn-gray' : darkBackground ? 'btn-outline-gray' : 'btn-outline-primary'"
                  [disabled]="!isComplete"
                  [routerLink]="isComplete ? ['/team/profile'] : []"
                >
                  See Team Profile
                </button>
              </div>
            </div>
          </div>
          <ng-template #individualViewDeskTop>
            <div *ngIf="!isTeamMemberView; else TeamMemberViewDeskTop" class="padding-buttons complete">
              <div *ngIf="!isShowingEmptyState()" class="w-100" style="display: contents">
                <div>
                  <button class="btn-primary" [disabled]="!isComplete || !isReportDownloadButtonActivated" (click)="downloadYourTypeReport()">
                    <span *ngIf="isReportDownloadButtonClicked">
                      <span class="spinner-border spinner-border-sm spinner-bottom-padding" role="status" aria-hidden="true"></span>
                    </span>
                    <span> Download Report </span>
                  </button>
                </div>
                <div class="button-spacer"></div>
                <div *ngIf="isSelf && !isMemberImported">
                  <button class="btn-outline-primary" (click)="openLearning()">Review Verification</button>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template #TeamMemberViewDeskTop>
            <div class="padding-buttons complete">
              <div *ngIf="!isSelf">
                <button class="btn-primary" [routerLink]="['/team']" [queryParams]="{ memberId: teamMember.memberId }">Compare</button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="d-block d-md-none w-100">
      <div class="d-flex justify-content-center buttonContainer">
        <div *ngIf="isTeamView; else individualViewMobile" class="w-100">
          <div class="padding-buttons w-100" [ngClass]="{ complete: isComplete }" *ngIf="!isShowingEmptyState()">
            <div class="w-100">
              <button
                class="w-100 d-flex justify-content-center align-items-center"
                [ngClass]="!isComplete ? 'btn-gray' : 'btn-primary'"
                [disabled]="!isComplete || !isTeamReportDownloadButtonActivated"
                (click)="downloadTeamTypeReport()"
              >
                <span *ngIf="!isTeamReportDownloadButtonActivated" class="d-flex justify-content-center align-items-center">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </span>
                <span>Download Your Team Type Report</span>
              </button>
            </div>
            <div class="button-spacer"></div>
            <div *ngIf="router.url !== '/team/profile'">
              <button
                class="w-100"
                [ngClass]="!isComplete ? 'btn-gray' : darkBackground ? 'btn-outline-gray' : 'btn-outline-primary'"
                [disabled]="!isComplete"
                [routerLink]="isComplete ? ['/team/profile'] : []"
              >
                See Team Profile
              </button>
            </div>
            <a
              class="btn btn-white d-flex justify-content-center align-items-center"
              href="https://e4hm6dz7g3.cpp.com/support/guides/Self-Directed-Teams-Facilitators-Guide-V2.pptx"
              >Download Facilitator's Guide</a
            >
          </div>
        </div>
        <ng-template #individualViewMobile>
          <div *ngIf="!isTeamMemberView; else TeamMemberViewMobile" class="padding-buttons complete w-100">
            <div *ngIf="!isShowingEmptyState()">
              <div>
                <button class="btn-primary w-100" [disabled]="!isComplete || !isReportDownloadButtonActivated" (click)="downloadYourTypeReport()">
                  Download Report
                </button>
              </div>
              <div class="button-spacer"></div>
              <div *ngIf="isSelf && !isMemberImported">
                <button class="btn-outline-primary w-100" (click)="openLearning()">Review Verification</button>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #TeamMemberViewMobile>
          <div class="padding-buttons complete w-100">
            <div *ngIf="!isSelf">
              <button class="btn-primary w-100" [routerLink]="['/team']" [queryParams]="{ memberId: teamMember.memberId }">Compare</button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
  <ng-template #lockedDownView>
    <div class="col-md-8 col-sm-6 blocked-header">
      <div style="padding-left: 3.125rem">
        <div class="content desktop team" [ngClass]="darkBackground ? 'dark-background' : 'light-background'">
          <div class="blocked-description">Finish your assessments to access this area</div>
        </div>
        <div class="padding-buttons complete">
          <div><button class="btn-primary" (click)="unlock()">Start Now</button></div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #lockedDownMobileView>
    <div class="content mobile team" [ngClass]="darkBackground ? 'dark-background' : 'light-background'">
      <div class="blocked-description">Finish your assessments to access this area</div>
    </div>
  </ng-template>
  <ng-template #editTeamMemberModal let-modal>
    <div class="teamReportProcessingModal">
      <div class="modal-intro">Your Team Type Report is being processed. You will be able to download the report shortly.</div>
      <div class="modal-footer">
        <button class="btn-primary" (click)="modal.dismiss()">Close</button>
      </div>
    </div>
  </ng-template>
</div>
